export default "__VITE_ASSET__C07bi2qD__"